import { Dialog } from '@mui/material';
import { FC, useRef } from 'react';
import { CrossCircleIcon } from '../../../../icons';
import { Button, ButtonColor } from '../../../atomic/button';

type Props = {
  open: boolean;
  title: string;
  variant?: ButtonColor;
  width?: string;
  primaryButton?: string;
  secondaryButton?: string;
  tertiaryButton?: string;
  primaryButtonDisabled?: boolean;
  onClose?: () => void;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  onTertiaryButtonClick?: () => void;
  children: JSX.Element;
};

export const ContentDialog: FC<Props> = ({
  open,
  title,
  variant = 'midnight',
  width,
  primaryButton,
  secondaryButton,
  tertiaryButton,
  primaryButtonDisabled = false,
  onClose,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  onTertiaryButtonClick,
  children
}) => {
  const dialogRef = useRef<HTMLDivElement>(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      disableAutoFocus
      disableRestoreFocus
      disableEnforceFocus
      sx={{
        '& .MuiDialog-paper': {
          width: width ?? '920px'
        }
      }}
    >
      <div ref={dialogRef}>
        <div className="flex justify-between py-4 px-6 items-center">
          <div className="text-lg font-bold text-primary-main">{title}</div>
          {onClose && (
            <div id="close">
              <CrossCircleIcon className="h-6 w-6 ml-6" onClick={onClose} />
            </div>
          )}
        </div>
        <div className="w-full border-solid border-[0.5px] border-grey-50" />
        <div className="p-6">{children}</div>
        {(primaryButton || secondaryButton || tertiaryButton) && (
          <>
            <div className="w-full border-solid border-[0.5px] border-grey-50" />
            <div className={`px-4 py-${variant === 'error' ? '3' : '4'} flex gap-x-6 justify-end`}>
              {tertiaryButton && (
                <Button variant="tertiary" onClick={onTertiaryButtonClick}>
                  {tertiaryButton}
                </Button>
              )}
              {secondaryButton && (
                <Button variant="secondary" onClick={onSecondaryButtonClick}>
                  {secondaryButton}
                </Button>
              )}
              {primaryButton && (
                <Button
                  variant="primary"
                  color={variant}
                  disabled={primaryButtonDisabled}
                  onClick={onPrimaryButtonClick}
                >
                  {primaryButton}
                </Button>
              )}
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
};
